import * as yup from 'yup';
import { hasContextSizeTag } from './utils';

function contextSizeTest(this: yup.TestContext, value: string | undefined) {
  if (!value) {
    return true;
  }

  const tags = (this.parent.tags as string[]) ?? [];

  if (!hasContextSizeTag(tags)) {
    return true;
  }

  const bytes = new Blob([value]).size;

  if (bytes > 50 * 1024) {
    const kb = (bytes / 1024).toFixed(1);

    return this.createError({
      message: `Text data must not exceed 50 KB for General context and Area context items (got ${kb} KB)`,
    });
  }
  return true;
}

export const validationSchemaCreate = yup.object({
  tags: yup.array(yup.string()).min(1).required('Required'),
  textData: yup
    .string()
    .required('Required')
    .test('context-size-limit', '', contextSizeTest),
});

export const validationSchemaCreateDoc = yup.object({
  tags: yup.array(yup.string()).min(1).required('Required'),
});

export const validationSchemaUpdate = yup.object({
  tags: yup.array(yup.string()).min(1).required('Required'),
  textData: yup.string().test('context-size-limit', '', contextSizeTest),
});
